import React from 'react'
import BlockLevelChart from '@berlitz/blocks/lib/BlockLevelChart'
import { getSerializedHTML } from '../../functions/utils'

const SliceLevelChart = ({ items, primary, pageLinks }) => {
  const {
    level_chart_title = '',
    level_chart_subtitle = '',
    chart_helper_label = '',
  } = primary
  return (
    <BlockLevelChart
      chartData={items.map(item => ({
        content: getSerializedHTML(item.content.richText, pageLinks),
        level: item.level,
        groupName: item.group_name,
        customLevelTitle: item.custom_level_title,
      }))}
      title={level_chart_title}
      subtitle={level_chart_subtitle.text}
      alignCenterTitle
      chartHelperLabel={
        chart_helper_label || 'Please select a level for more info'
      }
    />
  )
}

export default SliceLevelChart
